import type { FunctionComponent } from 'react';

import APRLineItem from 'components/APRLineItem';

import { CLASS_NAMES } from './constants';
import useAPRs from './useAPRs';

import type { FormattedRates } from '../constants';

export interface ChooseAPRProps {
  rates: FormattedRates | [];
  isLoading: boolean;
}

const ChooseAPR: FunctionComponent<ChooseAPRProps> = function ({
  rates,
  isLoading,
}) {
  const { options, optionsHasBuyNowPayLater } = useAPRs(rates);

  return (
    <>
      <p className="text-16-24-em md:text-18-22-em text-neutral-700 mb-2">
        {[
          'Pay Monthly Options',
          optionsHasBuyNowPayLater && 'Buy Now, Pay Later (BNPL)',
        ]
          .filter(Boolean)
          .join(' or ')}
      </p>
      <div className={CLASS_NAMES.lineItems}>
        {options.map(({ name, value }) => (
          <APRLineItem
            key={`rate-${name}`}
            name={name}
            value={value}
            isLoading={isLoading}
            rates={rates[value]}
          />
        ))}
      </div>
    </>
  );
};

export default ChooseAPR;
